<!-- 快速存放货物，目前用于新增编辑商品，转为库存商品功能 -->
<template>
    <div class="warehouseOut" v-loading="loading">
        <div class="warehouseOut-main">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 20%">配件名称</div>
                <div class="div-table-cell" style="width: 20%">配件编码</div>
                <div class="div-table-cell flex" style="width: 60%">
                    <div class="border-right cell-item" style="width: 24%">仓库</div>
                    <div class="border-right cell-item" style="width: 30%">仓位</div>
                    <div class="border-right cell-item" style="width: 26%">数量</div>
                    <div class="cell-item" style="width: 20%"></div>
                </div>
            </div>
            <div class="table-main">
                <div class="div-table-row" :key="autopartItem.EntpTempGoodsId">
                    <div class="div-table-cell" style="width: 20%">{{ autopartItem.GoodName }}</div>
                    <div class="div-table-cell" style="width: 20%">{{ autopartItem.APCode }}</div>
                    <div class="div-table-cell" style="width: 60%">
                        <!--循环仓库、仓位-->
                        <div class="cell-line" v-for="(warehouse, i) in formData.GoodsLocationList" :key="i.key">
                            <div class="border-right cell-item" style="width: 24%">
                                <el-select v-model="warehouse.WarehouseId" size="small" filterable clearable remote @change="warehouseChange($event, warehouse)">
                                    <el-option
                                        v-for="optionItem in WarehouseList"
                                        :label="optionItem.WarehouseName"
                                        :value="optionItem.WarehouseId"
                                        :key="optionItem.WarehouseId"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 30%">
                                <el-select
                                    v-model="warehouse.ShelfSpaceId"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    :remote-method="val => remoteMethod(val, warehouse.WarehouseId, warehouse)"
                                    @change="positionChange($event, warehouse)"
                                    @visible-change="positionVisibleChange($event, warehouse.WarehouseId, warehouse)"
                                    size="small"
                                >
                                    <el-option
                                        v-for="optionItem in warehouse.ShelfSpacesList"
                                        :key="optionItem.ShelfSpaceId"
                                        :label="optionItem.ShelfSpaceCode"
                                        :value="optionItem.ShelfSpaceId"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 26%">
                                <el-input-number type="number" v-model="warehouse.Count" controls-position="right" size="small" :min="1" :max="unInInventory"></el-input-number>
                            </div>
                            <div class="cell-item ops-ctn" style="width: 20%; height: 28px; margin-top: 7px">
                                <el-button size="mini" icon="el-icon-minus" @click="delItem(i)"></el-button>
                            </div>
                        </div>
                    </div>
                    <el-button size="mini" icon="el-icon-plus" class="add-btn" @click="addItem()"></el-button>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button class="btn-primary" size="small" @click="submitData">入仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['autopartItem', 'StoreType'], //StoreType,默认是7
    components: {},
    data() {
        return {
            loading: true,
            Limit: 10,
            WarehouseList: [],
            PositionList: [],
            unInInventory: 0,
            formData: {
                EntpTempGoodsId: '',
                GoodsLocationList: [
                    {
                        ShelfSpaceId: '',
                        Count: 0
                    }
                ]
            }
        };
    },
    mounted() {
        this.formData.StoreType = this.StoreType ? this.StoreType : '7';
        if (this.autopartItem.EntpTempGoodsId) {
            this.getUnInInventory().then(() => {
                let location = [
                    {
                        ShelfSpaceId: '',
                        Count: this.unInInventory,
                        ShelfSpacesList: []
                    }
                ];
                this.formData.EntpTempGoodsId = this.autopartItem.EntpTempGoodsId;
                this.formData.GoodsLocationList = location;
                this.getWarehouse();
            });
        } else {
            this.loading = false;
            this.$util.warningMsg('请选择商品');
        }
    },
    methods: {
        // 获取汽配的未入库的数量
        getUnInInventory() {
            return new Promise(resolve => {
                let that = this;
                that.$util
                    .axiosGet({
                        url: '/api/EntpShelfSpaces/GetEntpGoodsUnInInventory',
                        data: {
                            GoodsId: that.autopartItem.EntpTempGoodsId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) that.unInInventory = res.data;
                        resolve();
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            });
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util
                .getWarehouse()
                .then(data => {
                    this.WarehouseList = data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 搜仓位
        searchPosition(key, warehouseId) {
            let that = this;
            if (!warehouseId || that.loading) return;
            that.loading = true;
            return that.$util
                .GetShelfSpacesList({
                    WarehouseId: warehouseId,
                    ShelfSpaceCode: key,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: true
                })
                .then(res => {
                    that.loading = false;
                    if (res.data) {
                        that.PositionList = res.data;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.loading = false;
                });
        },
        warehouseChange(value, warehouse) {
            let that = this;
            warehouse.ShelfSpaceId = '';
            warehouse.ShelfSpacesList = [];
        },
        positionChange(value, warehouse) {
            if (!value) return;
            let that = this;
            let flag = 0;
            that.formData.GoodsLocationList.forEach(e => {
                if (e.ShelfSpaceId == value) {
                    flag++;
                    if (flag > 1) {
                        warehouse.ShelfSpaceId = '';
                        that.$util.warningMsg('同个商品不能选相同仓位');
                        return;
                    }
                }
            });
        },
        //仓位下拉框出现/隐藏时触发
        positionVisibleChange(val, warehouseId, shelfSpace) {
            if (!val || !warehouseId) return;
            let that = this;
            if (!(shelfSpace.ShelfSpacesList && shelfSpace.ShelfSpacesList.length > 0)) {
                that.searchPosition('', warehouseId).then(() => {
                    that.$set(shelfSpace, 'ShelfSpacesList', [...that.PositionList]);
                });
            }
        },
        remoteMethod(val, warehouseId, shelfSpace) {
            if (!val || !warehouseId) return;
            let that = this;
            that.searchPosition(val, warehouseId).then(() => {
                that.$set(shelfSpace, 'ShelfSpacesList', [...that.PositionList]);
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        submitData() {
            let _target = this.formData.GoodsLocationList;
            let _count = 0;
            for (let i = 0; i < _target.length; i++) {
                if (!_target[i].ShelfSpaceId) {
                    this.$util.warningMsg('请选择仓位');
                    return;
                }
                _count += _target[i].Count;
            }
            if (_count > this.unInInventory) {
                this.$util.warningMsg('已超出商品可存放的数量上限！');
                return;
            }
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpShelfSpaces/StoreEntpTempGoods',
                    data: this.formData,
                    hideLoading: true
                })
                .then((res) => {
                    this.$util.successMsg(res.errmsg);
                    this.$emit('closeDialog', true);
                    // this.loading=false;//成功后不隐藏loading,放在误点击
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        delItem(i) {
            if (this.formData.GoodsLocationList.length > 1) this.formData.GoodsLocationList.splice(i, 1);
        },
        addItem() {
            let _target = this.formData.GoodsLocationList;
            let _count = 0;
            for (let i = 0; i < _target.length; i++) {
                if (!_target[i].ShelfSpaceId) {
                    this.$util.warningMsg('请选择仓位');
                    return;
                }
                _count += _target[i].Count;
            }
            if (_count >= this.unInInventory) {
                this.$util.warningMsg('已达到商品可存放的数量上限！');
                return;
            }
            this.formData.GoodsLocationList.push({
                ShelfSpaceId: '',
                Count: this.unInInventory - _count,
                ShelfSpacesList: []
            });
        }
    }
};
</script>
<style lang="less" scoped>
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.ops-ctn {
    text-align: left !important;
}
.dialog-footer {
    text-align: right;
    margin-top: 20px;
}
.warehouseOut-main {
    padding-top: 20px;
}
.table-title {
    .cell-item {
        width: 33.33%;
    }
    .div-table-cell {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
}
.div-table-row {
    position: relative;
    overflow: visible;
}
.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .cell-line {
        display: flex;
        width: 100%;
    }
    .cell-item {
        padding: 0 10px;
        width: 33%;
        width: inherit;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
</style>
